<script lang="ts">
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { onMount } from 'svelte';

	import { refreshPendingUnitTransfers } from 'src/stores/account/pending_unit_transfers';
	import HomeSettingsLegacy from './HomeSettingsLegacy.svelte';
	import HomeSettingsV2 from './HomeSettingsV2.svelte';

	onMount(() => {
		void refreshPendingUnitTransfers();
	});
</script>

{#if $showNewLayout}
	<HomeSettingsV2 />
{:else}
	<HomeSettingsLegacy />
{/if}
